import { ReactNode } from "react";
import { translations, formatMoney } from "../Helpers/WindowHelpers";
import parse from 'html-react-parser';

interface HeadingProps {
    text: string,
    level: 1 | 2 | 3 | 4 | 5 | 6,
    price?: string,
    compare?: string,
    classes?: string,
    subtext?: string,
    modal?: ReactNode,
    children?: ReactNode
}

const Heading = ({ text, level, price, compare, subtext, classes, modal, children }: HeadingProps) => {
    const HeadingTag = `h${level}`
    return (
        <div className={`${classes || ''}`}>
            <div className="h4 option-name d--flex align-items--baseline gap-8 width--100">
                {/* @ts-ignore */}
                <HeadingTag>{text}</HeadingTag>
            </div>
            {price &&
                <div className="option-upsell d--flex align-items--baseline gap-8">
                    {`+${formatMoney(price)}`}
                    {compare &&
                        <s className="color--gray-muted">{formatMoney(compare)}</s>
                    }
                </div>
            }
            {subtext &&
                <div className="subtext rte links-underline">{parse(subtext ?? '')}</div>}
            {children && <div className="mt-8">{children}</div>}
        </div>
    )
}

export default Heading;